const LOAD_DATA_MASTER_CATEGORY         = 'LOAD_DATA_MASTER_CATEGORY'
const LOAD_DATA_MASTER_CATEGORY_SUCCESS = 'LOAD_DATA_MASTER_CATEGORY_SUCCESS'
const LOAD_DATA_MASTER_CATEGORY_FAILED  = 'LOAD_DATA_MASTER_CATEGORY_FAILED'
const UNMOUNT_DATA_MASTER_CATEGORY      = 'UNMOUNT_DATA_MASTER_CATEGORY'

const initialState = {
  loading: true,
  data: null,
  message: null,
  meta: null
}

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_MASTER_CATEGORY:
      return {
        ...state,
        loading: true,
        data: null,
        meta: null
      }
    case LOAD_DATA_MASTER_CATEGORY_SUCCESS:
      return {
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        meta: action.payload.meta
      }
    case LOAD_DATA_MASTER_CATEGORY_FAILED:
      return {
        ...state, 
        loading: false,
        data: null,
        message: 'FAILED',
        meta: null
      }
    case UNMOUNT_DATA_MASTER_CATEGORY:
      return { 
        ...state, 
        loading: true,
        data: null,
        meta: null
      }
    default:
      return state
  }
}
export default categoryReducer